import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserService } from '@ebf/core/user/services/user.service';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'ebf-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationBannerComponent {
  public isImpersonated$: Observable<boolean>;

  constructor(public readonly userService: UserService) {
    this.isImpersonated$ = this.userService.user$.pipe(map(() => this.userService.isImpersonated()));
  }

  public endImpersonation(): void {
    this.userService.endImpersonation().subscribe({
      next: () => {
        window.location.reload();
      },
    });
  }
}
